import CryptoJS from 'crypto-js';
import { postApi } from '../../lib/fetcher';
import { btoa, atob } from '../../lib/helpers';
import { dataIntervalExport } from '../params';

const transactionReconciliation = {
  namespaced: true,

  state() {
    return {
      allSettlement: [],
      totalSettlement: 0,
      isLoading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,

      totalPage: 0,
    };
  },

  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    clearSettlement(state) {
      state.allSettlement = [];
      state.totalSettlement = 0;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },
    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
    setSettlements(state, { payload }) {
      state.allSettlement = payload.data.list;
    },
    setTotalSettlements(state, { payload }) {
      state.totalSettlement = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      ctx.commit('clearSettlement');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';

      if (sortBy[0] != null) {
        if (sortBy[0] == 'mid') {
          sort_by = `mid_static ${sort}`;
        } else {
          sort_by = `${sortBy[0]} ${sort}`;
        }
      } else {
        sort_by = `id ${sort}`;
      }

      if (search.trx_datetime.length == 2) {
        const d1 = Date.parse(search.trx_datetime[0]);
        const d2 = Date.parse(search.trx_datetime[1]);

        if (d1 > d2) {
          const [trxDate1, trxDate2] = search.trx_datetime;

          // eslint-disable-next-line no-param-reassign
          search.trx_datetime[1] = trxDate1;
          // eslint-disable-next-line no-param-reassign
          search.trx_datetime[0] = trxDate2;
        }
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/reconciliation/transaction-reconciliation/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalSettlements', {
          payload: responseData,
        });
        ctx.commit('setSettlements', { payload: responseData });
      }
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, view, id }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );

        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';

      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => ctrl && 'export-transaction-reconciliation';

      const data = JSON.stringify({
        id,
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData.data.message,
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
          ctx.commit('setIsExport', false, { root: true });

          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);

        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },
  },
};

export default transactionReconciliation;
